import React, {useEffect} from 'react';
import {withRouter} from 'react-router';

import {Button} from '@albert-io/atomic';
import JoinClassroomModal from 'client/Classrooms/JoinClassroom/JoinClassroomModal';
import {useStudentDashboard} from '../../StudentDashboard/StudentDashboard.store';

/**
 * Represents student actions in their classes route shown in the secondary header.
 *
 * RightContent is dependent on a user's school value. We must ensure that is
 * requested before we render our New Class button.
 */

const RightContent = () => {
  const duplicateClassroom = useStudentDashboard((state) => state.duplicateClassroom);
  const isReady = useStudentDashboard((state) => state.isReady);
  const isRequestPending = useStudentDashboard((state) => state.isClassroomEnrollmentPending);
  const setShowJoinClassModal = useStudentDashboard((state) => state.setShowJoinClassModal);
  const showJoinClassModal = useStudentDashboard((state) => state.showJoinClassModal);

  useEffect(() => {
    setShowJoinClassModal(false);
  }, [duplicateClassroom, setShowJoinClassModal]);

  if (!isReady) {
    return null;
  }

  return (
    <>
      <Button
        disabled={isRequestPending}
        onClick={() => {
          setShowJoinClassModal(true);
        }}
        size='s'
      >
        Join a class
      </Button>
      {showJoinClassModal && (
        <JoinClassroomModal
          handleClose={() => {
            setShowJoinClassModal(false);
          }}
          onEnrollSuccess={() => {
            setShowJoinClassModal(false);
          }}
        />
      )}
    </>
  );
};

export default withRouter(RightContent);
